import CRM from "../assets/images/CRM.jpeg"
import IVR from "../assets/images/IVR.webp"
import WFM from "../assets/images/WFM.webp"
import chat_assistant from "../assets/images/Chat-Assistant.jpeg"
import call_center from "../assets/images/modem.png"

const CallByProjects = [
    {
        company: "Arkenom Tech",
        year: "2015",
        title: "Smart CRM for the Best Customer Experiences",
        results: [
            {"title": "Engage Smarter: All customer interactions in one smart platform"},
            {"title": "Simplify Payments: Automated billing, secure and flexible payment options"},
            {"title": "Empower Customers: Easy service requests, real-time tracking"},
            {"title": "Drive Decisions: Actionable insights powered by data analytics"}
        ],
        image: CRM,
    },
    {
        company: "Arkenom Tech",
        year: "2015",
        title: "Intelligent Call Center Solutions for Seamless Customer Engagement",
        results: [
            {"title": "AI-Powered Call Handling: Automate routine calls and reduce agent workload with smart self-service"},
            {"title": "Personalized Experiences: Respond dynamically with insights from caller history"},
            {"title": "Omnichannel Integration: Unify voice, SMS, email, and chatbot support on a single platform"},
            {"title": "Real-Time Analytics: Track performance live and optimize your operations instantly"},
        ],
        image: IVR,
    },
    {
        company: "Arkenom Tech",
        year: "2015",
        title: "Empower Your Workforce. Maximize Your Impact",
        results: [
            {"title": "Right People, Right Time: AI-powered smart scheduling that keeps your teams one step ahead"},
            {"title": "Do More with Less: Automate repetitive tasks and boost productivity effortlessly"},
            {"title": "See. Act. Improve.: Track performance live, optimize instantly"},
            {"title": "Cut Costs. Boost Results.: Turn data into smarter, leaner operations"}
        ],
        image: WFM,
    },
    {
        company: "Arkenom Tech",
        year: "2015",
        title: "AI-Powered Solutions for Smarter Customer Management",
        results: [
            {"title": "Handle Every Interaction: Seamlessly manage voice, chat, email, and all customer channels with AI-driven automation"},
            {"title": "Instant Process Management: Automate and manage business operations in seconds, increasing speed and efficiency"},
            {"title": "No Call, No Cost: When there’s no call, there’s no cost—AI handles routine needs digitally, cutting expenses especially during off-peak times"},
            {"title": "Smarter Engagement, Happier Customers: Deliver faster, smarter, and more satisfying customer experiences across every touchpoint"}
        ],
        image: chat_assistant,
    },
    {
        company: "Arkenom Tech",
        year: "2015",
        title: "AMR-Compatible IoT Modem",
        results: [
            {"title": "MQTT Compatible: Fully supports MQTT protocol for seamless IoT integration"},
            {"title": "MASS Certified: Compliant with industry standards for secure and reliable operations"},
            {"title": "100% Arkenom Innovation: Fully designed and manufactured by Arkenom Technology R&D Department"}
        ],
        image: call_center,
    }
];

export const Services = () => {
    return (
        <>
            <div className="w-full lg:max-w-7xl mx-auto px-6 lg:px-0">
                <div className="flex flex-col justify-center items-center mt-10 md:mt-6 gap-10">
                    {CallByProjects.map((project, projectIndex) => (
                        <div
                            key={project.title}
                            className="w-[100%] sm:w-[90%] 2xl:w-full pb-0 md:pt-12 ox-10 pt-2 sm:pt-16 px-2 sm:px-20 shadow-md hover:shadow-2xl transition-all duration-300 rounded-xl z-0 after:z-10 after:content-[''] after:absolute after:inset-0 after:outline-2 after:outline after:-outline-offset-2 after:rounded-xl after:outline-none after::pointer-events-none"
                            style={{
                                top: `calc(64px + ${projectIndex * 1}px)`,
                                background: '#fff'
                            }}
                        >
                            <div className="relative flex justify-center items-center xl:grid xl:grid-cols-4 xl:gap-16 min-h-[350px] sm:min-h-[550px]">
                                <div className="xl:pb-16 xl:col-span-2 text-center">
                                    <div className="bg-gradient-to-r from-emerald-300 to-[#1695c1] inline-flex gap-2 font-normal sm:font-bold uppercase tracking-widest text-[9px] sm:text-sm text-transparent bg-clip-text">
                                        <span>{project.company}</span>
                                        <span>&bull;</span>
                                        <span>{project.year}</span>
                                    </div>
                                    <h3 className="font-serif text-base sm:text-2xl mt-2 md:mt-5 md:text-4xl text-black/80">{project.title}</h3>
                                    <hr className="border-t-2 border-black/10 mt-4 md:mt-5" />
                                    <ul className="flex flex-col gap-4 mt-4 md:mt-5">
                                        {project.results.map(result => (
                                            <li key={result.title} className="flex items-center text-start gap-2 text-xs md:text-base text-black/60 hover:text-black transition duration-300">
                                                <span className="text-[#1695c1]">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5">
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="m8.99 14.993 6-6m6 3.001c0 1.268-.63 2.39-1.593 3.069a3.746 3.746 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043 3.745 3.745 0 0 1-3.068 1.593c-1.268 0-2.39-.63-3.068-1.593a3.745 3.745 0 0 1-3.296-1.043 3.746 3.746 0 0 1-1.043-3.297 3.746 3.746 0 0 1-1.593-3.068c0-1.268.63-2.39 1.593-3.068a3.746 3.746 0 0 1 1.043-3.297 3.745 3.745 0 0 1 3.296-1.042 3.745 3.745 0 0 1 3.068-1.594c1.268 0 2.39.63 3.068 1.593a3.745 3.745 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.297 3.746 3.746 0 0 1 1.593 3.068ZM9.74 9.743h.008v.007H9.74v-.007Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm4.125 4.5h.008v.008h-.008v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
                                                    </svg>
                                                </span>
                                                <span className="text-xs sm:text-lg">{result.title}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                                <div className="overflow-hidden rounded-xl hidden xl:block xl:col-span-2 w-[110%] shadow-slate-950" style={{ transform: 'translateY(-5%)', zIndex: 99 }}>
                                    <img
                                        src={project.image}
                                        alt={project.title}
                                        className="md:-mb-0 xl:mt-0 xl:h-full w-[100%] xl:max-w-none hover:scale-125 transition-transform duration-500"
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}
